import './Modal.scss';

export default function ModalDescription({ children }: any) {
  return (
    <div className="modal-description">
      <p>{children}</p>
    </div>
  );
}
